import * as React from 'react';
import useLiveData from 'hooks/useLiveData';
import { useStaticQuery, graphql } from 'gatsby';
import { parse } from 'node-html-parser';
import reactParse from 'html-react-parser';

const buildTag = (node) => {
	if (typeof node === 'string') return reactParse(node);
	let tagName = 'meta';
	for (let attribute in node) {
		if (attribute.localeCompare('tagname', 'en', { sensitivity: 'base' }) === 0) {
			tagName = attribute.toLowerCase();
			delete node[attribute];
		}
	}
	const parsed = React.createElement(tagName, node);
	return parsed;
}

export const Head = (props) => {
	const data = useStaticQuery(graphql`
		query htmlHead {
		  allContentPage {
		    edges {
		      node {
		        uri
		        pageTitle
		        meta
		      }
		    }
		  }
		  site {
		    siteMetadata {
		      title
			  description
		      siteUrl
		      shareImage
		    }
		  }
		}
	`);
	let LiveDataParams = {
		type: 'ContentPage',
		method: 'all',
		apiParams: {
			_include: 'uri,pageTitle,meta',
		},
		staticData: data,
	}
	let contentType = 'ContentPage';
	const { response: providerResponse } = useLiveData(LiveDataParams);

	// if (!providerResponse)return null;
	if (props.data?.allPressRelease !== undefined) {
		if (props.location.pathname === '/news/') {
			contentType = 'ContentPage';
		} else {
			contentType = 'PressRelease';
		}
	}
	if (props.data?.allBlogPost !== undefined) {
		if (props.location.pathname === '/insights/') {
			contentType = 'ContentPage';
		} else {
			contentType = 'BlogPost';
		}
	}
	if (props.data?.allPortfolioCaseStudy !== undefined) {
		if (props.location.pathname === '/case-studies/') {
			contentType = 'ContentPage';
		} else {
			contentType = 'PortfolioCaseStudy';
		}
	}
	if (props.data?.allPortfolioIndustry !== undefined) {
		if (props.location.pathname === '/industries/') {
			contentType = 'ContentPage';
		} else if (props.data?.allPortfolioCaseStudy !== undefined) {
			contentType = 'PortfolioCaseStudy';
		} else {
			contentType = 'PortfolioIndustry';
		}
	}
	if (props.data?.allPortfolioClient !== undefined) {
		contentType = 'PortfolioClient';
	}
	let pages = providerResponse.data.filter(item => item.uri === props.location.pathname);
	const siteURL = data.site.siteMetadata.siteUrl;
	let pageTitle = props.pageContext?.seoTitle||data.site.siteMetadata.title;
	let shareImage = data.site.siteMetadata.shareImage;
	let description = props.pageContext?.seoDescription||data.site.siteMetadata.description;
	const meta = [];
	switch (contentType) {
		case 'ContentPage':
			if (pages.length > 0) {
				const pageData = pages[0];
				pageTitle = pageData.pageTitle;
				if (pageData.meta) {
					if (typeof pageData.meta === 'string') {
						const root = parse(pageData.meta);
						root.querySelectorAll('meta').forEach((node) => {
							meta.push(node.attributes);
						});
						if (root.querySelector('title')) {
							pageTitle = root.querySelector('title').text;
						};
					}
				}
			}
			break;
		
		case 'PressRelease': {
			const node = (props.data?.allPressRelease?.edges?.length > 0 ? props.data.allPressRelease.edges[0].node : null);
			if (node) {
				if (node.headline && !props.pageContext?.seoTitle)pageTitle = `${node.headline} | Zehnder`;
				if (node.excerpt && !props.pageContext?.seoDescription)description = node.excerpt;
				if (node.photo)shareImage = node.photo;
			}
			break;
		}

		case 'BlogPost': {
			const node = (props.data?.allBlogPost?.edges?.length > 0 ? props.data.allBlogPost.edges[0].node : null);
			if (node) {
				if (node.title && !props.pageContext?.seoTitle)pageTitle = `${node.title} | Zehnder`;
				if (node.intro && !props.pageContext?.seoDescription)description = node.intro;
				if (node.photo)shareImage = node.photo;
			}
			break;
		}

		case 'PortfolioCaseStudy': {
			const node = (props.data?.allPortfolioCaseStudy?.edges?.length > 0 ? props.data.allPortfolioCaseStudy.edges[0].node : null);
			if (node) {
				if (node.title && !props.pageContext?.seoTitle)pageTitle = `${node.title} - Case Study | Zehnder`;
				if (node.intro && !props.pageContext?.seoDescription)description = node.intro;
				if (node.headerImage)shareImage = node.headerImage;
			}
			break;
		}

		case 'PortfolioIndustry': {
			const node = (props.data?.allPortfolioIndustry?.edges?.length > 0 ? props.data.allPortfolioIndustry.edges[0].node : null);
			if (node) {
				if (node.name && !props.pageContext?.seoTitle)pageTitle = `${node.name} Industry | Zehnder`;
				if (node.description && !props.pageContext?.seoDescription)description = node.description;
				if (node.headerImage)shareImage = node.headerImage;
			}
			break;
		}

		case 'PortfolioClient': {
			const node = (props.data?.allPortfolioClient?.edges?.length > 0 ? props.data.allPortfolioClient.edges[0].node : null);
			if (node) {
				if (node.name && !props.pageContext?.seoTitle)pageTitle = `${node.name} | Zehnder`;
				if (node.intro && !props.pageContext?.seoDescription)description = node.intro;
				if (node.headerImage)shareImage = node.headerImage;
			}
			break;
		}

		default:
	}

	if (meta.filter(node => node.name === 'description').length > 0) {
		description = meta.filter(node => node.name === 'description')[0].content;
		if (meta.filter(node => node.property === 'og:description').length === 0) meta.push({ property: 'og:description', content: description });
	} else if (!!description !== false) {
		meta.push({ name: 'description', content: description });
		meta.push({ property: 'og:description', content: description });
	}
	if (shareImage && meta.filter(node => node.property === 'og:image').length === 0) {
		meta.push({ property: 'og:image', content: `${siteURL}/${shareImage}` });
	}
	meta.push(`<title>${pageTitle}</title>`);
	return (
		<>
			{meta.map((node, index) => {
				let hash = '';
				if (typeof node === 'string') {
					hash = node.toLowerCase().replace(/[^a-z]/g, '');
				} else {
					hash = `meta${Object.keys(node).join('')}${Object.values(node).join('')}`.toLowerCase().replace(/[^a-z]/g, '');
				}
				return <React.Fragment key={hash}>{buildTag(node)}</React.Fragment>
			})}
		</>
	)
}